export var ERentioFormField;
(function (ERentioFormField) {
    ERentioFormField["AdditionalCost"] = "rentio:field:additional_cost";
    ERentioFormField["Address"] = "rentio:field:address";
    ERentioFormField["AddressStreet"] = "rentio:field:address_street";
    ERentioFormField["Array"] = "rentio:field:array";
    ERentioFormField["Captcha"] = "rentio:field:captcha";
    ERentioFormField["ContactSelectInlineV2"] = "rentio:field:contact_select_inline_v2";
    ERentioFormField["Date"] = "rentio:field:date";
    ERentioFormField["DocumentSelectInline"] = "rentio:field:document_select_inline";
    ERentioFormField["DropdownSelect"] = "rentio:field:dropdown_select";
    ERentioFormField["Email"] = "rentio:field:email";
    ERentioFormField["Grid"] = "rentio:field:grid";
    ERentioFormField["HelpInfo"] = "rentio:field:help_info";
    ERentioFormField["Iban"] = "rentio:field:iban";
    ERentioFormField["RentmatchScore"] = "rentio:field:rentmatch_score";
    ERentioFormField["PropertyPhotos"] = "rentio:field:property_photos";
    ERentioFormField["IncomeRanges"] = "rentio:field:income_ranges";
    ERentioFormField["IbanSelectInline"] = "rentio:field:iban_select_inline";
    ERentioFormField["InlineSelect"] = "rentio:field:inline_select";
    ERentioFormField["Label"] = "rentio:field:label";
    ERentioFormField["ManualLatePaymentsSelect"] = "rentio:field:manual_payments_select";
    ERentioFormField["Number"] = "rentio:field:number";
    ERentioFormField["Phone"] = "rentio:field:phone";
    /** A body of text a broker may format. Stores HTML (DEV-3323). */
    ERentioFormField["RichText"] = "rentio:field:rich_text";
    ERentioFormField["PhoneOrEmail"] = "rentio:field:phone_or_email";
    ERentioFormField["PropertyInfo"] = "rentio:field:property_info";
    ERentioFormField["PropertySelectInline"] = "rentio:field:property_select_inline";
    ERentioFormField["Root"] = "rentio:field:object:root";
    ERentioFormField["SectionHeader"] = "rentio:field:section_header";
    ERentioFormField["SectionSubtitle"] = "rentio:field:section_subtitle";
    ERentioFormField["SegmentedControl"] = "rentio:field:segmented_control";
    ERentioFormField["Switch"] = "rentio:field:switch";
    ERentioFormField["SwitchContactSelect"] = "rentio:field:switch_contact_select";
    ERentioFormField["Text"] = "rentio:field:text";
})(ERentioFormField || (ERentioFormField = {}));
export var ERentioFormFormat;
(function (ERentioFormFormat) {
    ERentioFormFormat["Email"] = "email";
    ERentioFormFormat["VATNumber"] = "vat-number";
    ERentioFormFormat["NationalRegisterNumber"] = "national-register-number";
})(ERentioFormFormat || (ERentioFormFormat = {}));
